import m from "../../geodata/es2015/norwayHigh";
window.am4geodata_norwayHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/norwayHigh.js
// module id = null
// module chunks = 